import React, { ReactNode } from 'react';
import type { CSSProperties } from 'react';
import Text from '../text/Text';
import {
    Accordion as MaterialAccordion,
    AccordionSummary,
    AccordionDetails,
    styled,
    type SxProps,
    type Theme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function Accordion({
    title,
    children,
    defaultExpanded = true,
    sx,
    textStyle,
    className,
}: {
    title: string | ReactNode;
    children: ReactNode;
    defaultExpanded?: boolean;
    sx?: SxProps<Theme>;
    textStyle?: CSSProperties;
    className?: string;
}) {
    return (
        <MaterialAccordion defaultExpanded={defaultExpanded} elevation={0} sx={sx} className={className}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ padding: 0 }}>
                {typeof title === 'string' ? (
                    <Text bold variant="body1" textStyle={textStyle}>
                        {title}
                    </Text>
                ) : (
                    title
                )}
            </AccordionSummary>
            <DetailsSection>{children}</DetailsSection>
        </MaterialAccordion>
    );
}

const DetailsSection = styled(AccordionDetails)({
    padding: 0,
});
